import { render, staticRenderFns } from "./MetricKpi.vue?vue&type=template&id=245fa9d6&"
import script from "./MetricKpi.vue?vue&type=script&lang=js&"
export * from "./MetricKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports